import { Component, Input, inject } from '@angular/core';
import { FormatterService } from '../../services/formatter.service';

@Component({
  selector: 'app-accordion-panel',
  styleUrls: ['./accordion-panel.component.scss'],
  templateUrl: './accordion-panel.component.html',
  standalone: false
})
export class AccordionPanelComponent {
  private readonly formatService = inject(FormatterService);

  @Input()
  public open = false;

  @Input()
  public disabled: boolean;

  @Input()
  public subtitle: string;

  @Input()
  public title: string;

  public getTitle(): string {
    return this.formatService.userFriendlyString(this.title);
  }

  public getSubtitle(): string {
    return this.formatService.userFriendlyString(this.subtitle);
  }
}
